import React from "react";
import { Outlet } from "react-router-dom";
import { Layout, Space, FloatButton } from "antd";
import AppHeader from "../app-header";
import AppFooter from "../app-footer";
import "./app-layout.css";
import BackTopBtn from "../static/arrow-top.svg";
import ScrollToTop from "./scroll-to-top";

const { Header, Footer, Content } = Layout;

const IconBackTopBtn = () => (
  <div>
    <img src={BackTopBtn} alt="Кнопка наверх" width={"100%"} loading="lazy" />
  </div>
);

const AppLayout = () => (
  <>
    <ScrollToTop />
    <Space
      direction="vertical"
      style={{
        width: "100%",
      }}
      size={[0, 48]}
    >
      <Layout
        style={{
          backgroundColor: "#36322F",
        }}
      >
        <Header
          style={{
            backgroundColor: "#36322F",
            height: "auto",
            padding: 0,
          }}
        >
          <AppHeader />
        </Header>
        <Content>
          <Outlet />
          <FloatButton.BackTop
            className="back-top-btn"
            icon={<IconBackTopBtn />}
          />
        </Content>
        <Footer
          style={{
            backgroundColor: "#36322F",
            height: "222px",
            padding: 0,
          }}
        >
          <AppFooter />
        </Footer>
      </Layout>
    </Space>
  </>
);
export default AppLayout;
